import React from "react";
import { highlightText } from "../../../util/highlightText";
import { IFlexibleSetTileProps } from "../../../types/suggestion-items";
import { ITelemetryData, TelemetryContentEnum } from "../../../types/telemetry";
import { sendTelemetryData } from "../../../util/telemetry";
import { useL10nContext, useNavigationContext } from "../../common/contexts";
import FlexibleImageGrid from "./flexible-image-grid/flexible-image-grid";
import FlexibleSetPrice from "./article-price/set-price";
import EyeCatcher from "./eye-catcher/eye-catcher";
import { DiscountEnum, EyeCatcherTypeEnum } from "../../../types/article-price";

const FlexibleSetTile = (props: IFlexibleSetTileProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();
    const { decodeFlexSetsL10n, imageMainView } = useL10nContext();
    const flexSetsL10n = decodeFlexSetsL10n();

    const anchorClassName = `ssw-suggested-${props.product.type.toLowerCase()}-${props.setIndex}`;
    const ongoingMatchingProductsIndex = props.articleCount + props.setIndex;
    const anchorSemantic = `ssw-suggested-${TelemetryContentEnum.Articles.toLowerCase()}-${ongoingMatchingProductsIndex}`;

    const shouldShowEyeCatcher =
        props.product.price &&
        (props.product.price.discountType === DiscountEnum.DynamicPrice ||
            props.product.price.discountType === DiscountEnum.FixedPrice);

    const renderSetDetails = () => {
        const articleL10n =
            props.product.articleCount > 1 ? flexSetsL10n.articles : flexSetsL10n.article;

        return (
            <div className="product-article-count">{`${props.product.articleCount} ${articleL10n}`}</div>
        );
    };

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        handleTouched(props.product.navIndex);
        recordProductUsed();
        window.location.href = props.product.url;
    };

    const recordProductUsed = () => {
        const data: ITelemetryData = {
            correlationId: props.searchInfo.pageViewLogDataId,
            culture: props.searchInfo.culture,
            portal: props.searchInfo.portal,
            searchTerm: props.searchInfo.searchTerm,
            shortLink: props.product.shortLink,
            suggestion: props.product.title,
            contentType: props.product.type
        };
        sendTelemetryData(data, props.searchInfo.trackingEndpoint);
    };

    return (
        <div
            ref={(el) => props.setRef(props.product.navIndex, el)}
            onMouseEnter={() => handleMouseSelect(props.product.navIndex)}
            onMouseLeave={handleMouseDeselect}
            className={`suggestion-item ${props.product.type.toLowerCase()}`}
        >
            <a
                className={anchorClassName}
                href={props.product.url}
                onClick={handleClick}
                data-testid={anchorSemantic}
                data-semantic-id={anchorSemantic}
            >
                <FlexibleImageGrid
                    article={null}
                    set={props.product}
                    imageMainView={imageMainView}
                />
                <div className="article-info">
                    <span className="article-name">
                        {highlightText(props.product.title, props.searchInfo.searchTerm)}
                    </span>
                    {shouldShowEyeCatcher && props.product.price && (
                        <EyeCatcher
                            discountPercentage={props.product.price.discountPercentage}
                            eyeCatherType={EyeCatcherTypeEnum.SetPrice}
                        />
                    )}
                    {props.showPrices && props.product.price && (
                        <FlexibleSetPrice
                            prices={props.product.price}
                            priceSettingsV2={props.priceMandantSettingsV2}
                        />
                    )}
                    {renderSetDetails()}
                </div>
            </a>
        </div>
    );
};

export default FlexibleSetTile;
